import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-white font-sans text-navy selection:bg-energy selection:text-navy" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ijpcgysnsv8p">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3ii4s22026sok" />
        </noscript>

        <Hero data-id="element-4" data-mp="6817u0q2c9h" />
        <main data-id="element-5" data-mp="4n53zyrel9i">
          <ProblemSection data-id="element-6" data-mp="5gbgztt38r4" />
          <SolutionSection data-id="element-7" data-mp="7sxbo2oq39g" />
          <BonusesSection data-id="element-8" data-mp="2zlli5ahfl0qy" />
          <BenefitsSection data-id="element-9" data-mp="2zmemy5wtxg6g" />
          <OfferSection data-id="element-10" data-mp="2zn6cp03qwjot" />
          <GuaranteeSection data-id="element-11" data-mp="33mf1dqjxhrdi" />
          <Testimonials data-id="element-12" data-mp="33nq4do5juv3k" />
          <FAQSection data-id="element-13" data-mp="33mymth8sexwa" />
          <FinalCTA data-id="element-14" data-mp="33oi152avuyvf" />
        </main>
        <Footer data-id="element-15" data-mp="38li7zffk45nl" />
        <PurchasePopup data-id="element-16" data-mp="38l04pyuh8r66" />
      </div>
    </MotionConfig>;
}